export default __webpack_public_path__ + "media/images/fancybox/fancy_title_over-cef7fc2a855959b0caaf4ca97244035b.png";